<script setup lang="ts">
const props = withDefaults(defineProps<{
  /**
   * 折叠时高度
   * @default 32
   */
  foldHeight?: number

  /**
   * 方向
   * @default 'horizontal'
   */
  direction?: 'vertical' | 'horizontal'
}>(), {
  foldHeight: 32,
  direction: 'horizontal',
})

const [expand, toggleExpand] = useToggle()
const boxRef = ref()
const { height: boxHeight } = useElementSize(boxRef)

const cls = computed(() => {
  if (props.direction === 'horizontal') {
    return 'flex justify-between'
  }
  return 'relative'
})
</script>

<template>
  <div class="w-full" :class="cls">
    <template v-if="direction === 'horizontal'">
      <div
        class="overflow-hidden transition-height"
        :style="{ height: !expand ? `${foldHeight}px` : '' }"
      >
        <div ref="boxRef" class="w-full">
          <slot />
        </div>
      </div>
      <a-button v-if="boxHeight > foldHeight" type="text" size="small" class="px-8 text-12 !b-none" @click="toggleExpand()">
        <span>{{ expand ? $t('收起') : $t('展开') }}</span>
        <i class="icon-zhankai ml-2 transition-transform" :class="{ 'transform-rotate-180': expand }" />
      </a-button>
    </template>

    <template v-else>
      <div rd-inherit :style="{ 'max-height': expand ? '' : `${foldHeight}px`, 'overflow': expand ? 'inherit' : 'hidden' }">
        <div ref="boxRef" class="w-full">
          <slot />
        </div>
      </div>
      <div v-if="!expand && boxHeight > foldHeight" class="absolute bottom-0 left-0 h-142 w-full flex items-center justify-center bg-[#FFFFFFE5]">
        <slot name="vertical-fold-modal">
          <a-button type="text" @click="toggleExpand(true)">
            {{ $t('查看更多数据') }}<i class="icon-zhankai" />
          </a-button>
        </slot>
      </div>
    </template>
  </div>
</template>

<style scoped>
</style>
